import { render, staticRenderFns } from "./FRM_Traficos.vue?vue&type=template&id=0d06c5a0&"
import script from "./FRM_Traficos.vue?vue&type=script&lang=js&"
export * from "./FRM_Traficos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports